<template>
    <div class="footer">
        <img :src="require('@/assets/Romomo.png')" alt="">
        上海容么么数字科技有限公司
    </div>
</template>

<script>
import FooterBottom from './FooterBottom.js'
export default FooterBottom
</script>

<style lang="scss" scoped>
@import "./FooterBottom.scss";
</style>


// WEBPACK FOOTER //
// src/components/FooterBottom/FooterBottom.vue